const footerSocials = [
  { logo: 'https://img.icons8.com/color/96/youtube-play.png', href: 'https://www.youtube.com/@ShayGeneration', label: 'YouTube' },
  { logo: 'https://img.icons8.com/color/96/instagram-new--v1.png', href: 'https://www.instagram.com/shay_this_generation', label: 'Instagram' },
  { logo: 'https://img.icons8.com/color/96/facebook.png', href: 'https://www.facebook.com/profile.php?id=61578513957131', label: 'Facebook' },
  { logo: 'https://img.icons8.com/color/96/whatsapp.png', href: 'https://whatsapp.com/channel/0029VbCjXXHFcow1ohd1CY09', label: 'WhatsApp' },
];

const FooterSection = () => {
  return (
    <footer
      id="footer"
      className="relative overflow-hidden"
      style={{ background: 'linear-gradient(180deg, #0a0a0a 0%, #050505 100%)' }}
    >
      <div
        className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-px pointer-events-none"
        style={{ background: 'linear-gradient(90deg, transparent, rgba(212,168,66,0.5), transparent)' }}
      />

      {/* Main footer */}
      <div className="max-w-3xl mx-auto px-6 py-16 text-center">
        <img
          src="https://static.readdy.ai/image/d9bb5601c98f22586a2b11870925187d/71d6a8a551d583ad95743263bd4e0791.png"
          alt="SHAY Logo"
          className="h-16 w-auto object-contain mx-auto mb-6"
        />

        {/* Revive Nation — Holy Midnight */}
        <h2
          className="text-3xl md:text-4xl font-black mb-1"
          style={{ fontFamily: "'Holy Midnight', cursive", color: '#FFFFFF', letterSpacing: '0.01em' }}
        >
          Revive Nation
        </h2>

        {/* Reclaim Conference — Bacalisties */}
        <h3
          className="text-xl font-bold mb-6"
          style={{ fontFamily: "'Bacalisties', cursive", color: '#D4A842', letterSpacing: '0.03em' }}
        >
          Reclaim Conference
        </h3>

        <div className="flex flex-col gap-1 mb-8">
          <p className="text-sm text-gray-500" style={{ fontFamily: "'Glacial Indifference', sans-serif" }}>
            Presented by <strong className="text-gray-300">SHAY</strong>
          </p>
          <p className="text-sm text-gray-500" style={{ fontFamily: "'Glacial Indifference', sans-serif" }}>
            <strong className="text-gray-300">Bible Believers Tabernacle</strong>
          </p>
        </div>

        {/* 3 dates summary — Blinker for dates */}
        <div className="flex flex-wrap justify-center gap-3 mb-10">
          {[
            { text: '11 Apr — Arilova', mapUrl: 'https://maps.app.goo.gl/5SeBP2c5JtbELpTMA' },
            { text: '18 Apr — Madhurawada', mapUrl: 'https://maps.app.goo.gl/o1wUS4msXwoj9RDy9' },
            { text: '25 Apr — Yendada', mapUrl: 'https://maps.app.goo.gl/UrVabfG6nACTBy4m7' },
          ].map((d) => (
            <a
              key={d.text}
              href={d.mapUrl}
              target="_blank"
              rel="nofollow noreferrer"
              className="px-4 py-2 rounded-full text-xs font-semibold cursor-pointer hover:opacity-80 transition-opacity"
              style={{
                background: 'rgba(212,168,66,0.08)',
                border: '1px solid rgba(212,168,66,0.2)',
                color: '#C9A030',
                fontFamily: "'Blinker', sans-serif",
                textDecoration: 'none',
              }}
            >
              {d.text} · 4 PM
            </a>
          ))}
        </div>

        {/* Social icons */}
        <div className="flex justify-center gap-5 mb-10">
          {footerSocials.map((s) => (
            <a
              key={s.label}
              href={s.href}
              rel="nofollow noreferrer"
              target="_blank"
              aria-label={s.label}
              className="w-12 h-12 flex items-center justify-center cursor-pointer transition-transform hover:scale-110 flex-shrink-0"
            >
              <img
                src={s.logo}
                alt={`${s.label} logo`}
                className="w-10 h-10 object-contain"
              />
            </a>
          ))}
        </div>

        {/* Contact */}
        <a
          href="tel:+919502891444"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-full text-sm font-semibold cursor-pointer transition-transform hover:scale-105"
          style={{
            background: 'rgba(255,255,255,0.04)',
            border: '1px solid rgba(212,168,66,0.25)',
            color: '#D4A842',
            fontFamily: "'Glacial Indifference', sans-serif",
          }}
        >
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-phone-fill text-sm" />
          </div>
          95028 91444
        </a>

        <div
          className="h-px w-32 mx-auto my-10"
          style={{ background: 'linear-gradient(90deg, transparent, rgba(212,168,66,0.4), transparent)' }}
        />

        <p className="text-xs text-gray-700" style={{ fontFamily: "'Glacial Indifference', sans-serif" }}>
          &copy; 2026 Revive Nation – Reclaim Conference. Presented by SHAY.
        </p>
      </div>
    </footer>
  );
};

export default FooterSection;
